/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CreatedVsResolvedReportEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const createdVsResolvedReportEntrypoint: EntryPoint<
	CreatedVsResolvedReportEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<CreatedVsResolvedReportEntrypointComponent>(
		/* webpackChunkName: "async-reports-created-vs-resolved-entrypoint" */ './CreatedVsResolvedReportPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
